/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, amount: NonNullable<unknown> }} Ticketsrefundbody2Inputs */

const en_ticketsrefundbody2 = /** @type {(inputs: Ticketsrefundbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} gets ${i?.amount} back, the ticket fee included. All tickets of this order become invalid.`)
};

const de_ticketsrefundbody2 = /** @type {(inputs: Ticketsrefundbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} bekommt ${i?.amount} zurück, auch die Ticketgebühr. Alle Tickets dieser Bestellung werden ungültig.`)
};

/**
* | output |
* | --- |
* | "{name} gets {amount} back, the ticket fee included. All tickets of this order become invalid." |
*
* @param {Ticketsrefundbody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsrefundbody2 = /** @type {((inputs: Ticketsrefundbody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsrefundbody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsrefundbody2(inputs)
	return de_ticketsrefundbody2(inputs)
});
export { ticketsrefundbody2 as "ticketsRefundBody" }